import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import MyAccountQuery from 'Query/MyAccount.query';
import { CustomerType } from 'Type/Account.type';
import { MixType } from 'Type/Common.type';
import { fetchQuery } from 'Util/Request/Query';

import MyAccountPushPages from './MyAccountPushPages.component';

/** @namespace PeggysagePwa/Component/MyAccountPushPages/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isMobile: state.ConfigReducer.device.isMobile,
    customer: state.MyAccountReducer.customer
});

/** @namespace PeggysagePwa/Component/MyAccountPushPages/Container/mapDispatchToProps */
export const mapDispatchToProps = (_dispatch) => ({
    // ...
});

/** @namespace PeggysagePwa/Component/MyAccountPushPages/Container */
export class MyAccountPushPagesContainer extends PureComponent {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        customer: CustomerType.isRequired,
        mix: MixType
    };

    static defaultProps = {
        mix: {}
    };

    state = {
        items: [],
        isLoading: true
    };

    containerFunctions = {
        // ...
    };

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        const { customer: { group_id: groupId = 0 } = {} } = this.props;
        const { customer: { group_id: prevGroupId = 0 } = {} } = prevProps;

        if (groupId !== prevGroupId) {
            this.updateItems();
        }
    }

    updateItems() {
        const { items } = this.state;

        this.setState({ items: this.filterItems(items) });
    }

    filterItems(items = []) {
        const { customer: { group_id: groupId = 0 } = {} } = this.props;

        return items.filter((item) => {
            const { limitation_customer_group_ids: allowedCustomerGroupIds = [] } = item;

            return (
                !allowedCustomerGroupIds
                || !allowedCustomerGroupIds.length
                || allowedCustomerGroupIds.includes(0)
                || allowedCustomerGroupIds.includes(groupId)
            );
        });
    }

    async getData() {
        fetchQuery(MyAccountQuery.getPushPageAccount()).then(
            /** @namespace PeggysagePwa/Component/MyAccountPushPages/Container/MyAccountPushPagesContainer/getData/then/catch/fetchQuery/then */
            (res) => {
                const items = res.getPushPageAccount;

                this.setState({
                    items: this.filterItems(items),
                    isLoading: false
                });
            }
        ).catch(
            /** @namespace PeggysagePwa/Component/MyAccountPushPages/Container/MyAccountPushPagesContainer/getData/then/catch */
            () => {
                this.setState({ isLoading: false });

                Promise.reject();
            }
        );
    }

    containerProps() {
        const { isMobile, mix } = this.props;
        const { items, isLoading } = this.state;

        return {
            items,
            isLoading,
            isMobile,
            mix
        };
    }

    render() {
        return (
            <MyAccountPushPages
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountPushPagesContainer);
